module.exports = __webpack_public_path__ + "img/browser-gauge.6abe93f8.svg";